import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c585fc82&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c585fc82&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c585fc82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c585fc82')) {
      api.createRecord('c585fc82', component.options)
    } else {
      api.reload('c585fc82', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c585fc82&scoped=true", function () {
      api.rerender('c585fc82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bulkyExpress/largeJobManagement/collectingLoadingRecords/index.vue"
export default component.exports